module.exports = __webpack_public_path__ + "static/media/intro@2x.069aca35.webp";